export enum EntityName {
  All = 'All',
  Event = 'Event',
  Venture = 'Venture',
  Person = 'Person',
  Organization = 'Organization',
  Challenge = 'Challenge',
  News = 'News',
  Message = 'Message',
  Tenant = 'Tenant',
  Group = 'Group',
  InnovationSpace = 'InnovationSpace',
  ServiceDefinition = 'ServiceDefinition',

  // Only using for News & Messages
  VentureSubmitOrganisation = 'VentureSubmitOrganisation',
  VentureSubmittedToChallenge = 'VentureSubmittedToChallenge',
  VentureAwarded = 'VentureAwarded',
  Post = 'Post',
  NewsMessage = 'NewsMessage',
  GroupCommunity = 'GroupCommunity',
  CreatedInInnovationSpace = 'CreatedInInnovationSpace',
}

export enum EntityStateCount {
  Liking = 'Liking',
  Following = 'Following',
  Comment = 'Comment',
  Venture = 'Venture',
  Event = 'Event',
  Participant = 'Participant',
}

export enum EntityViewMode {
  TileView,
  TableView,
  FullscreenView,
}

export enum MessageType {
  News = 'News',
  Message = 'Message',
  VentureMessage = 'VentureMessage',
  OrganizationMessage = 'OrganizationMessage',
  ChallengeMessage = 'ChallengeMessage',
  EventMessage = 'EventMessage',
  PersonMessage = 'PersonMessage',
  GroupMessage = 'GroupMessage',
  InnovationSpaceEntityMessage = 'InnovationSpaceEntityMessage',
}

export enum MessageAction {
  Unknow = 0,
  Created = 1,
  Updated = 2,
  Shared = 3,
  GetInTouch = 4,

  VentureSubmittedOrganization = 5,
  UserJoined = 6,
  Approved = 7,
  Rejected = 8,
  UnavailablePendingMember = 9,

  PendingRequest = 10,
  WelcomeMessage = 11,
  RemovedMember = 12,
  Registered = 13,
  VentureAwarded = 14,

  DeactivatedEntity = 15,
  RemovedMyselfFromMember = 16,
  VentureSubmittedToChallenge = 17,
  NewVentureSubmittedToChallenge = 18,
  AcceptedSubmittedVenture = 19,
  RefusedSubmittedVenture = 20,
  NewVentureSubmittedToOrganization = 21,
  Post = 22,
  InviteJuror = 23,
  AcceptJuror = 24,
  DenyJuror = 25,
  WelcomeJuror = 26,
  AskForRating = 27,
  GroupInternalMessage = 28,

  LeaveGroup = 29,
  JoinGroup = 30,
  DeactivateGroup = 31,

  SendToAllJurors = 32,
  SendToAllPendingJurors = 33,
  SendToAllFinishedJurors = 34,

  CreatedInInnovationSpace = 35,

  Liked = 36,
  Followed = 37,

  ChallengeSubmissionStarted = 38,

  WithdrawnPendingMember = 39,

  RecommendedVenture = 40,

  AddPersonToThread = 41,
}

export enum MessageValidation {
  MaxLength = 2500,
}

export enum SupportMessage {
  Event = 'Event',
  Challenge = 'Challenge',
}
